/*=========================================================================================
  File Name: moduleAuthMutations.js
  Description: Auth Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import { getApplicationLocalStorageItem, setApplicationLocalStorageItem } from "../../helpers";

export default {
  ADD_NAVIGATION_HISTORY(state, newNavigationHistory) {
    // const navigationHistory = JSON.parse(JSON.stringify(state.navigationHistory));
    // navigationHistory.push(newNavigationHistory);
    // state.navigationHistory = state.navigationHistory.push(newNavigationHistory);
    state.navigationHistory.push(newNavigationHistory);
    setApplicationLocalStorageItem('relatedModuleNavigation', JSON.stringify(state.navigationHistory));
  },
  CLEAR_NAVIGATION_HISTORY(state) {
    state.navigationHistory = [];
    setApplicationLocalStorageItem('relatedModuleNavigation', JSON.stringify([]));
  },
  RELOAD_STATE(state) {
    state.navigationHistory = JSON.parse(getApplicationLocalStorageItem('relatedModuleNavigation'))
  }
};
